<template>
  <div class="py-2">
    <div class="py-2">
      <div class="py-2">
        <label for="inputState" class="block text-gray-700 text-sm font-bold mb-2">Select Post:</label>
        <select
          v-model="service"
          @change="onPriceChange()"
          class="block appearance-none w-auto bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
        >
          <option disabled value>Choose one</option>
          <option v-for="(service, id) in services" :value="service.id" :key="id">{{ service.name }}</option>
        </select>
      </div>

      <div class="py-2">
        <router-link
          to="/shipping"
          class="bg-teal-400 text-white ml-2 p-1 hover:bg-white hover:text-teal-400"
        >
          <i class="fa fa-plus"></i>
          Add Shipping
        </router-link>
        <vue-excel-xlsx
          class="ml-2 my-2 p-1 text-white bg-teal-400 hover:text-teal-400 hover:bg-white"
          :data="products"
          :columns="columns"
        >
          <i class="fa fa-file-excel"></i>
          Export
        </vue-excel-xlsx>
      </div>
    </div>

    <vue-good-table
      @on-selected-rows-change="selectionChanged"
      :columns="columns"
      :rows="products"
      :fixed-header="true"
      :search-options="{ enabled: true}"
      :sort-options="{ enabled: true}"
      :pagination-options="{ enabled: true}"
      :select-options="{ enabled: true}"
    >
      <div slot="selected-row-actions">
        <vue-excel-xlsx :data="selectedProducts" :columns="columns">Export</vue-excel-xlsx>
      </div>
    </vue-good-table>
  </div>
</template>

<script>
import axios from "axios";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";

export default {
  components: {
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: "Name",
          field: "name"
        },
        {
          label: "Code",
          field: "code"
        },
        {
          label: "Price",
          field: "price"
        },
        {
          label: "Cbm",
          field: "cbm"
        },
        {
          label: "Kg",
          field: "kg"
        },
        {
          label: "Coli",
          field: "coli"
        },
        {
          label: "Drop Shipping Cost",
          field: "calculated price"
        },
        {
          label: "Final Price",
          field: "final price"
        }
      ],
      products: [],
      selectedProducts: [],
      services: [],
      value: "",
      service: ""
      // isLoading: false
    };
  },
  created() {
    this.getProducts();
    this.getServices();
  },
  methods: {
    async getProducts() {
      try {
        let response = await axios.get(
          `${process.env.VUE_APP_API}/calculate/products`
        );
        this.products = response.data;
      } catch (err) {
        console.log(err);
      }
    },
    getServices() {
      axios
        .get(`${process.env.VUE_APP_API}/calculate/services`)
        .then(response => {
          this.services = response.data;
        });
    },
    onPriceChange() {
      axios
        .get(
          `${process.env.VUE_APP_API}/calculate/products?postal_id=${this.service}`
        )
        .then(response => {
          this.products = response.data;
        });
    },
    selectionChanged(params) {
      this.selectedProducts = params.selectedRows;
    }
  }
};
</script>

<style>
</style>